import checkIcon from 'assets/img/quiz/option-select-check.png';
import crossIcon from 'assets/img/quiz/option-select-cross.png';

export const SelectItemOverlay = (props: { enableGrayOverlay?: boolean; icon?: 'check' | 'cross' }) => {
    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                background: !props.enableGrayOverlay
                    ? 'none'
                    : 'linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))',
            }}
        >
            <img
                src={props.icon === 'cross' ? crossIcon : checkIcon}
                width={24}
                alt={'select-item-cross'}
                style={{ position: 'absolute', top: 4, left: 4 }}
            />
        </div>
    );
};
